import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {DetailsTabContentWrapper} from '@/features/projects/components/details-tab-content-wrapper/DetailsTabContentWrapper'
import {ProjectMedicalDevicesSection} from '@/features/projects/components/project-medical-devices-section/ProjectMedicalDevicesSection'
import {ProjectOtherPathologiesSection} from '@/features/projects/components/project-other-pathologies-section/ProjectOtherPathologiesSection'
import {ProjectMainPathologiesSection} from '@/features/projects/components/project-main-pathologies-section/ProjectMainPathologiesSection'
import {useTranslation} from '@/translations/i18n'
import {useState} from 'react'
import {Helmet} from 'react-helmet'
import {useOutletContext} from 'react-router-dom'
import {ProjectExtended} from '@/features/projects/types'

export type CardInEditModeType =
    | 'ProjectMainPathologiesSection'
    | 'ProjectOtherPathologiesSection'
    | 'ProjectMedicalDevicesSection'
    | null

export const ProjectDetailsDiagnosesFacilities = () => {
    const {t} = useTranslation()
    const {project} = useOutletContext<{project: ProjectExtended}>()
    const editModeState = useState<CardInEditModeType>(null)

    return (
        <DetailsTabContentWrapper>
            <Helmet
                title={t('commons:fullname_details_meta_title', {
                    fullName: project.patient.fullName
                })}
            />
            <Flexbox direction="column" gap={4} fullWidth align="stretch">
                <ProjectMainPathologiesSection projectId={project.id} editModeState={editModeState} />
                <ProjectOtherPathologiesSection projectId={project.id} editModeState={editModeState} />
                <ProjectMedicalDevicesSection projectId={project.id} editModeState={editModeState} />
            </Flexbox>
        </DetailsTabContentWrapper>
    )
}
